<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Image from '../components/image.svelte';
	import type { TeamMember } from '../types';

	interface Props {
		content: ISbStoryData<TeamMember>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="relative">
	<Image
		src={content.image?.filename}
		class="h-full w-full object-cover"
		alt={content.image.alt}
		title={content.image.title}
		width={580}
	/>
	<div
		class="pointer-events-none absolute inset-x-0 bottom-0 z-0 h-1/3 rounded-b-lg xl:h-1/4 2xl:rounded-b-xl"
		style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);"
	></div>
	<div class="absolute bottom-0 flex flex-col gap-y-1 p-6 font-semibold text-stone-5">
		<p class="text-[12px]/[110%] lg:text-[16px]">
			{content.title}
		</p>

		<p class="text-[20px]/[110%] lg:text-[24px]">
			{content.name}
		</p>
	</div>
</div>
